module.exports = __webpack_public_path__ + "15ce7b5be1a01831349d5219c73439bb.jpg";